"use client";

import { ChevronDownIcon } from "@/components/event-detail/chevron-down-icon";
import { calc, get } from "@/utils/utils";
import dayjs from "dayjs";
import { useState } from "react";
import { ClockIcon } from "./clock-icon";
import { VolumeIcon } from "./volume-icon";

interface AboutSectionProps {
    event: any;
}

export function AboutSection( { event }: AboutSectionProps ) {
    const [ isExpanded, setIsExpanded ] = useState( false );

    return (
        <div className="mb-3 rounded-xl border border-stroke bg-surface-card p-3">
            <button
                onClick={() => setIsExpanded( !isExpanded )}
                className="flex h-6 w-full items-center justify-between"
            >
                <h2 className="text-[16px] font-bold leading-6 text-t1">About</h2>
                <ChevronDownIcon
                    className={`size-6 text-t3 transition-transform duration-200 ${isExpanded ? "rotate-180" : ""}`}
                />
            </button>

            <div
                className={`overflow-hidden transition-all duration-200 ${
                    isExpanded ? "mt-2 max-h-[1000px] opacity-100" : "max-h-0 opacity-0"
                }`}
            >
                <div className="flex flex-col gap-2">
                    {/* Volume */}
                    <div className="flex min-h-6 items-center justify-between gap-3">
                        <div className="flex min-w-0 items-center gap-2">
                            <VolumeIcon className="size-6 shrink-0" />
                            <span className="text-sm font-medium text-t1">Volume</span>
                        </div>
                        <span className="shrink-0 text-right text-sm font-normal text-t1 tabular-nums">
                            {calc( "tradeAmount | <=2!ub:$", event )}
                        </span>
                    </div>

                    {/* End Date */}
                    <div className="flex min-h-6 items-center justify-between gap-3">
                        <div className="flex min-w-0 items-center gap-2">
                            <ClockIcon className="size-6 shrink-0" />
                            <span className="text-sm font-medium text-t1">End Date</span>
                        </div>
                        <span className="shrink-0 text-right text-sm font-normal text-t1 tabular-nums">
                            {get( event, "acceptEndTime", 0 ) > 0
                                ? dayjs( get( event, "acceptEndTime", 0 ) ).format( "MMM DD, YYYY" )
                                : get( event, "eventEndTime", 0 ) > 0
                                ? dayjs( get( event, "eventEndTime", 0 ) ).format( "MMM DD, YYYY" )
                                : "-"}
                        </span>
                    </div>

                    {/* Created At */}
                    <div className="flex min-h-6 items-center justify-between gap-3">
                        <div className="flex min-w-0 items-center gap-2">
                            <ClockIcon className="size-6 shrink-0" />
                            <span className="text-sm font-medium text-t1 whitespace-nowrap">Created At</span>
                        </div>
                        <span className="max-w-[208px] text-end text-sm font-normal leading-snug text-t1 whitespace-nowrap tracking-[-0.5px] tabular-nums">
                            {get( event, "eventPublishTime", 0 ) > 0
                                ? dayjs( get( event, "eventPublishTime", 0 ) ).format( "MMM DD, YYYY, h:mm A [GMT]Z" )
                                    .replace( /([+-])(\d{2}):(\d{2})/, ( _, sign, hours ) =>
                                        `${sign}${parseInt( hours, 10 )}` )
                                : "-"}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}
